import { z } from "zod";

// API-boundary contract for the message-translation endpoint. Plain zod (no
// drizzle / pg-core) so the mobile bundle stays decoupled from the DB package.
// The API route parses every request against this; the mobile client sends the
// same shape by hand. The success response is a bare translated string,
// validated client- and server-side with `z.string()` (no schema constant
// needed for a primitive).
export const TranslateMessageInputSchema = z.object({
  messageId: z.string().uuid(),
});

/**
 * POST /twilio/message/send's refusal, worded by the client (`RefusalFields`).
 * `property_preparing` and `subscription_required` are the write gate's own.
 */
export const SendMessageRefusalSchema = z.object({
  code: z.enum([
    "invalid_phone_number",
    "property_preparing",
    "subscription_required",
    "whatsapp_not_connected",
  ]),
});
export type SendMessageRefusal = z.infer<typeof SendMessageRefusalSchema>;
